module.exports = __webpack_public_path__ + "static/media/HairBack_3.1db0f2cc.jpg";